import { isPlatformBrowser } from '@angular/common';
import {  ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'clever-percent',
    templateUrl: './percent.component.html',
    styleUrls: ['./percent.component.scss'],
    standalone: false
})
export class PercentComponent implements OnInit, OnDestroy {
    protected unsubscribe$ = new Subject();
    @Input() mode: string;
    isBrowser: boolean = false;
    currentSelected: number = 0;
    step: number = 5;

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    initFilterSub(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            this.currentSelected = Number(filter.recommendation);
            this.cdr.markForCheck();
        });
    }

    selectValue(val) {
        if (this.currentSelected === val) {
            this.currentSelected = 0;
        } else {
            this.currentSelected = val;
        }

        this.hotelService.recommendation(this.currentSelected, this.mode !== 'home');
    }

    valueChange(): void {
        this.hotelService.recommendation(this.currentSelected, this.mode !== 'home');
    }
}
